import {HTTP_METHODS} from '../httpMethods'

export const UPLOAD_IMAGES_CONFIG = {
  UPLOAD_IMAGES: () => ({
    endPoint: `image/upload`,
    method: HTTP_METHODS.POST,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
    contentType: 'multipart/form-data',
    multipart: 'multipart',
  }),
  UPLOAD_PROMOTION_IMAGES: () => ({
    endPoint: `promotion/image/upload`,
    method: HTTP_METHODS.POST,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
    contentType: 'multipart/form-data',
    multipart: 'multipart',
  }),
  UPLOAD_PRODUCT_MEDIA: productId => ({
    endPoint: `product/${productId}/media`,
    method: HTTP_METHODS.PUT,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl',
    contentType: 'multipart/form-data',
    multipart: 'multipart',
  }),
  DELETE_PRODUCT_MEDIA: (productId, displayOrder) => ({
    endPoint: `product/${productId}/media/order/${displayOrder}`,
    method: HTTP_METHODS.DELETE,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl',
  }),
}
